export default __webpack_public_path__ + "static/media/alarma.15fad935.svg";